import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as AuthActions } from '../constants/AuthConstants';

import { events as AuthEvents } from '../constants/AuthConstants';

class AuthStoreClass extends EventEmitter {

    boot(nav) {
        _state.nav = nav;

        this.emitChange();
    }

    emitChange( callback ) {
        this.emit(AuthEvents.CHANGE_EVENT, callback)
    }

    addChangeListener( callback ) {
        this.on(AuthEvents.CHANGE_EVENT, callback)
    }

    removeChangeListener( callback ) {
        this.removeListener(AuthEvents.CHANGE_EVENT, callback)
    }
}

const AuthStore = new AuthStoreClass();

AuthStore.dispatchToken = AppDispatcher.register(action => {
    switch(action.actionType) {

        case AuthActions.LOGIN:
            if (!action.data) {
                AuthStore.emitChange({
                    event : 'login',
                    error : true,
                    user  : action.user,
                });
            }
            break;

        case AuthActions.SSO_LOGIN:
            if (!action.data) {
                AuthStore.emitChange({
                    event : 'ssologin',
                    error : true,
                });
            }
            break;

        case AuthActions.LOGOUT:
            AuthStore.emitChange({
                event : 'logout'
            });
            break;
    }
});

export default AuthStore



// WEBPACK FOOTER //
// ./ui_src/app/stores/AuthStore.jsx